<div class="ds-breadcrumbs">
  <ng-container *ngFor="let page of pages; let i = index">
    <span class="ds-breadcrumbs__page" [ngClass]="{'last': i === pages.length - 1}"
          [innerHTML]="page.title" [routerLink]="page.path"></span>
    <i class="db-icon db-icon-ds-arrow-small" *ngIf="i < pages.length - 1"></i>
  </ng-container>
  <i class="db-icon db-icon-ds-info-bg knowledge-base-toggle" *ngIf="showToggle" (click)="toggleKnowLedgeBase()"></i>
</div>
